import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./index.js";
import { Cambio } from "./contexto/ClasesGrales";
import { HOY, toInput, toOutput, SInput, SEtiqueta, SInputD, Scrudo } from "./general";
import Boton from "./Boton.js";

export default function CRUDcambio({ cambio, set }) {
  // set permite actualizar variable para visualizar pantalla
  let { firebase } = useContext(AppContext);

  const [c, setC] = useState(cambio ? cambio : new Cambio(firebase.proyectoActivo.proyecto.id, "...nuevo..."));
  const [imageAsFile, setImageAsFile] = useState(null);
  const [change, setChange] = useState(false)

  useEffect(() => {
    document.getElementById("Cfechai").value = toInput(c.inicio);
    document.getElementById("Cfechac").value = c.fechaCierre ? toInput(c.fechaCierre) : null;
  }, [c.inicio, c.fechaCierre]);

  async function actualizarCambio() {
    if (imageAsFile) {
      const uploadTask = firebase.storage.ref(`cambios/${c.proyecto}/${c.id}/${c.adjunto.nombre}`).put(imageAsFile);

      uploadTask.on(
        "state_changed",
        (snapShot) => {
          var progress = (snapShot.bytesTransferred / snapShot.totalBytes) * 100;
          console.log("Upload de Cambio is " + progress + "% done");
        },
        (err) => {
          console.log("Error al cargar el documento de cambio", err);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            c.adjunto.url = downloadURL; // no se puede actualizar con setC
            firebase.actualizarCambio(c);
            set(false)
          });
        }
      );
    } else {
      firebase.actualizarCambio(c);
      set(false)
    }
    setChange(false)
  }

  return (
    <div style={Scrudo}>
      <div style={Sdescripcion}>
        <div style={{ ...SEtiqueta, marginBottom: "5px" }}>{c.id} - Descripción:</div>
        <textarea
          rows="4"
          style={SInputD}
          value={c.descripcion}
          onChange={(e) => {
            e.persist(); setChange(true);
            setC((c) => ({ ...c, descripcion: e.target.value }));
          }}
        ></textarea>
      </div>

      <div style={SDataEntry}>
        <div style={SEtiqueta}>Estado:</div>
        <select
          style={SInput}
          value={c.estado}
          onChange={(e) => {
            e.persist(); setChange(true);
            setC((c) => ({ ...c, estado: e.target.value, fechaCierre: e.target.value === "cerrado" ? HOY : 0 }));
          }}
        >
          <option value="pendiente">Pendiente</option>
          <option value="aprobado">Aprobado</option>
          <option value="no aprobado">No Aprobado</option>
          <option value="cerrado">Cerrado</option>
        </select>
        <div style={SEtiqueta}>Fecha Inicio:</div>
        <input
          id="Cfechai"
          type="date"
          style={SInput}
          onChange={(e) => {
            e.persist(); setChange(true);
            setC((c) => ({ ...c, inicio: toOutput(e.target.value) }));
          }}
        ></input>
        <div style={SEtiqueta}>Fecha Cierre:</div>
        <input
          id="Cfechac"
          type="date"
          style={SInput}
          onChange={(e) => {
            e.persist(); setChange(true);
            setC((c) => ({ ...c, fechaCierre: toOutput(e.target.value) }));
          }}
        ></input>
        <div style={SEtiqueta}>Adjunto:</div>
        <input
          type="file"
          style={SInput}
          onChange={(e) => {
            e.persist(); setChange(true);
            setImageAsFile(e.target.files[0]);
            setC((c) => ({ ...c, adjunto: { ...c.adjunto, nombre: e.target.files[0].name } }));
          }}
        ></input>
      </div>
      <Boton accion={actualizarCambio} change={change} />

    </div>
  );
}


const Sdescripcion = {
  marginBottom: "5px"
};

const SDataEntry = {
  display: "grid",
  gridTemplateColumns: "55% 40%",
  rowGap: "5px",
  columnGap: "5px"
};



